import { graphql } from 'gatsby'
import PricingPage from '../views/pricing'

export default PricingPage
export const query = graphql`
  query PricingQuery($slug: String, $locale: String) {
    header: contentfulHeader(node_locale: { eq: $locale }) {
      ...headerFragment
    }
    footer: contentfulFooter(node_locale: { eq: $locale }) {
      ...footerFragment
    }
    waitingList: contentfulCtaSection(
      page: { elemMatch: { node_locale: { eq: $locale }, slug: { eq: $slug } } }
    ) {
      ...waitingListFragment
    }
    hero: contentfulHeroSection(
      page: { elemMatch: { node_locale: { eq: $locale }, slug: { eq: $slug } } }
    ) {
      ...heroFragment
    }
    page: contentfulPage(slug: { eq: $slug }, node_locale: { eq: $locale }) {
      feature: pageSection {
        ... on ContentfulPriceListBlock {
          id
          priceHeading
          priceListText {
            raw
          }
          description
          updatedAt
          priceList {
            APR
            Admin_Fee
            Asset_Type
            Balloon_Payment_Amount
            Balloon_Payment_Percentage
            Car_Price_VAT_Inclusive
            Down_Payment_Amount
            Down_Payment_Percentage
            Finance_Amount
            Installment_Amount
            Insurance_Percentage
            Loan_Duration
            Total_Finance_Amount
          }
        }
      }
      metaDescription
      metaTag
      title
      slug
    }
  }
`
